import React from "react"
import {Button} from 'primereact/button';
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {addressTypeOption} from "../../entities/Constants";
import {Checkbox} from "primereact/checkbox";
import { Accordion, AccordionTab } from "primereact/accordion";

import {DialogBase, Props, State} from "./DialogBase";


export class DialongforAddressComponent extends DialogBase<Props,State> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={"Set up API for section " + this.props.ele.ENUTitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.addressHtml()}
                </Dialog>
            </>
        );
        return html;
    }

    renderAddressLabelOverrideAccordion = () => {
        const addressFields = [
            { key: "unitType", label: "Unit type" },
            { key: "unitNumber", label: "Unit number" },
            { key: "streetNumber", label: "Street number" },
            { key: "streetNumberSuffix", label: "Street number suffix" },
            { key: "streetName", label: "Street name" },
            { key: "streetType", label: "Street type" },
            { key: "streetDirection", label: "Street direction" },
            { key: "routeType", label: "Route type" },
            { key: "routeNumber", label: "Route number" },
            { key: "ruralRoute", label: "Rural route" },
            { key: "poBoxNumber", label: "P.O. Box" },
            { key: "lotType", label: "Lot type" },
            { key: "lotNumber", label: "Lot/part number" },
            { key: "propertyIdentifier", label: "Property identifier" },
            { key: "identifierNumber", label: "Identifier number" },
            { key: "township", label: "Township" },
            { key: "municipality", label: "Municipality/City" },
            { key: "province", label: "Province" },
            { key: "provinceOther", label: "Other province" },
            { key: "postalCode", label: "Postal code" },
            { key: "country", label: "Country" },
        ];

        const mapKey = this.props.isEng ? 'addressFieldLabels' : 'addressFieldLabelsFRA';
        const requirementIndicatorMapKey = 'hideAddressFieldRequirementIndicators';
        if (!this.props.ele[mapKey]) {
            this.props.ele[mapKey] = {};
        }
        if (!this.props.ele[requirementIndicatorMapKey]) {
            this.props.ele[requirementIndicatorMapKey] = {};
        }

        const hideConfigByField = {
            unitNumber: {
                checked: !!this.props.ele.hideUnitNumber,
                onChange: (checked: boolean) => { this.props.ele.hideUnitNumber = checked; }
            },
            unitType: {
                checked: !!this.props.ele.hideUnitType,
                onChange: (checked: boolean) => { this.props.ele.hideUnitType = checked; }
            },
            township: {
                checked: !!this.props.ele.hideTownship,
                onChange: (checked: boolean) => { this.props.ele.hideTownship = checked; }
            },
            streetNumberSuffix: {
                checked: !!this.props.ele.hideStreetNumberSuffix,
                onChange: (checked: boolean) => { this.props.ele.hideStreetNumberSuffix = checked; }
            },
            streetType: {
                checked: !!this.props.ele.hideStreetType,
                onChange: (checked: boolean) => { this.props.ele.hideStreetType = checked; }
            },
            streetDirection: {
                checked: !!this.props.ele.hideStreetDirection,
                onChange: (checked: boolean) => { this.props.ele.hideStreetDirection = checked; }
            },
        };

        return (
            <div style={{ marginTop: '14px' }}>
                <Accordion>
                    <AccordionTab header={this.props.isEng ? "Address field label overrides" : "Remplacements des étiquettes des champs d’adresse"}>
                        <div style={{ display: "flex", marginTop: '4px', marginBottom: '8px', fontWeight: 600 }}>
                            <div style={{ width: '25%' }}>{this.props.isEng ? 'Field' : 'Champ'}</div>
                            <div style={{ width: '35%' }}>{this.props.isEng ? 'Display label' : 'Étiquette affichée'}</div>
                            <div style={{ width: '20%' }}>{this.props.isEng ? 'Hide' : 'Masquer'}</div>
                            <div style={{ width: '20%' }}>{this.props.isEng ? 'Hide Req/Opt' : 'Masquer Obl/Fac'}</div>
                        </div>
                        {addressFields.map((item) => (
                            <div key={`${item.key}_${this.props.ele.Sequence}`} style={{ display: "flex", marginTop: '10px', alignItems: 'center' }}>
                                <div style={{ width: '25%' }}>
                                    <label htmlFor={`address_field_label_${item.key}_${this.props.ele.Sequence}`}>{item.label}</label>
                                </div>
                                <div style={{ width: '35%' }}>
                                    <InputText
                                        id={`address_field_label_${item.key}_${this.props.ele.Sequence}`}
                                        className="ontario-input"
                                        value={this.props.ele[mapKey]?.[item.key] || ''}
                                        onChange={(e) => {
                                            if (!this.props.ele[mapKey]) {
                                                this.props.ele[mapKey] = {};
                                            }
                                            const nextValue = (e.target.value || '');
                                            if (!nextValue) {
                                                delete this.props.ele[mapKey][item.key];
                                            } else {
                                                this.props.ele[mapKey][item.key] = nextValue;
                                            }
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                                <div style={{ width: '20%' }}>
                                    {hideConfigByField[item.key] ? (
                                        <>
                                            {/* @ts-ignore */}
                                            <Checkbox
                                                value={hideConfigByField[item.key].checked}
                                                id={`address_field_hide_${item.key}_${this.props.ele.Sequence}`}
                                                checked={hideConfigByField[item.key].checked}
                                                onChange={(e) => {
                                                    hideConfigByField[item.key].onChange(!!e.checked);
                                                    this.props.callback();
                                                }}
                                            />
                                        </>
                                    ) : null}
                                </div>
                                <div style={{ width: '20%' }}>
                                    {/* @ts-ignore */}
                                    <Checkbox
                                        value={!!this.props.ele[requirementIndicatorMapKey]?.[item.key]}
                                        id={`address_field_hide_requirement_${item.key}_${this.props.ele.Sequence}`}
                                        checked={!!this.props.ele[requirementIndicatorMapKey]?.[item.key]}
                                        onChange={(e) => {
                                            if (!this.props.ele[requirementIndicatorMapKey]) {
                                                this.props.ele[requirementIndicatorMapKey] = {};
                                            }
                                            this.props.ele[requirementIndicatorMapKey][item.key] = !!e.checked;
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </AccordionTab>
                </Accordion>
            </div>
        )
    }

    renderAddressErrorOverrideAccordion = () => {
        const errorFields = [
            { key: "identifier", label: "Property identifier" },
            { key: "identifierNumber", label: "Identifier number" },
            { key: "lotType", label: "Lot type" },
            { key: "lotNumber", label: "Lot/part number" },
            { key: "unitType", label: "Unit type" },
            { key: "suiteNumber", label: "Unit number" },
            { key: "routeType", label: "Route type" },
            { key: "routeNumber", label: "Route number" },
            { key: "township", label: "Township" },
            { key: "streetNumber", label: "Street number" },
            { key: "streetName", label: "Street name" },
            { key: "municipality", label: "Municipality/City" },
            { key: "province", label: "Province" },
            { key: "provinceOther", label: "Other province" },
            { key: "postalCode", label: "Postal code" },
        ];

        const mapKey = this.props.isEng ? 'addressErrorMessages' : 'addressErrorMessagesFRA';
        if (!this.props.ele[mapKey]) {
            this.props.ele[mapKey] = {};
        }

        return (
            <div style={{ marginTop: '14px' }}>
                <Accordion>
                    <AccordionTab header={this.props.isEng ? "Address field error overrides" : "Remplacements des messages d’erreur des champs d’adresse"}>
                        <div style={{ display: "flex", marginTop: '4px', marginBottom: '8px', fontWeight: 600 }}>
                            <div style={{ width: '30%' }}>{this.props.isEng ? 'Field' : 'Champ'}</div>
                            <div style={{ width: '70%' }}>{this.props.isEng ? 'Error message' : 'Message d’erreur'}</div>
                        </div>
                        {errorFields.map((item) => (
                            <div key={`${item.key}_err_${this.props.ele.Sequence}`} style={{ display: "flex", marginTop: '10px', alignItems: 'center' }}>
                                <div style={{ width: '30%' }}>
                                    <label htmlFor={`address_field_error_${item.key}_${this.props.ele.Sequence}`}>{item.label}</label>
                                </div>
                                <div style={{ width: '70%' }}>
                                    <InputText
                                        id={`address_field_error_${item.key}_${this.props.ele.Sequence}`}
                                        className="ontario-input"
                                        value={this.props.ele[mapKey]?.[item.key] || ''}
                                        onChange={(e) => {
                                            if (!this.props.ele[mapKey]) {
                                                this.props.ele[mapKey] = {};
                                            }
                                            const nextValue = (e.target.value || '');
                                            if (!nextValue) {
                                                delete this.props.ele[mapKey][item.key];
                                            } else {
                                                this.props.ele[mapKey][item.key] = nextValue;
                                            }
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </AccordionTab>
                </Accordion>
            </div>
        )
    }

    addressHtml = () => {
        let htmlString = [];
        htmlString.push(
            <>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"API_for_postal_code_search"}>API for postal code search</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"API_for_postal_code_search"} value={this.props.ele.PCLookupUrl} className="ontario-input"
                            onChange={(e) => { this.props.ele.PCLookupUrl = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"API_for_address_search"}>API for address search </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"API_for_address_search"} value={this.props.ele.AddressLookupUrl} className="ontario-input"
                            onChange={(e) => { this.props.ele.AddressLookupUrl = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                
                {this.regexHtml()}

                {this.questionHintHtml()}

                {this.tooTipHtml()}

                {this.emptyErrorMessageHtml()}

                {this.errorMessageHtml()}

                {this.hintExpansionTitleHtml()}

                {this.calloutBoxHtml()}

                {this.scriptHtml()}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-partial" + this.props.ele.Sequence}>Allowing partial adress: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.allowPartialAddress} id={"allow-partial" + this.props.ele.Sequence}
                            checked={this.props.ele.allowPartialAddress}
                            onChange={(e) => { this.props.ele.allowPartialAddress = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Allowing manual edit: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.allowManualAddress} id={"allow-manual-edit" + this.props.ele.Sequence}
                            checked={this.props.ele.allowManualAddress}
                            onChange={(e) => { this.props.ele.allowManualAddress = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>                        <label htmlFor={"clear-address-on-manual-check" + this.props.ele.Sequence}>Clear address fields on manual check: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.clearAddressOnManualCheck} id={"clear-address-on-manual-check" + this.props.ele.Sequence}
                            checked={this.props.ele.clearAddressOnManualCheck}
                            onChange={(e) => { this.props.ele.clearAddressOnManualCheck = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>                        <label htmlFor={"manual-address-entry-label" + this.props.ele.Sequence}>
                            {this.props.isEng ? 'Manual address entry label:' : 'Libellé de saisie manuelle de l’adresse :'}
                        </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            key={"manual-address-entry-label" + this.props.ele.Sequence}
                            id={"manual-address-entry-label" + this.props.ele.Sequence}
                            className="ontario-input"
                            value={this.props.isEng ? (this.props.ele.manualAddressEntryLabel || '') : (this.props.ele.manualAddressEntryLabelFRA || '')}
                            onChange={(e) => {
                                const nextValue = e.target.value || '';
                                if (this.props.isEng) {
                                    this.props.ele.manualAddressEntryLabel = nextValue;
                                } else {
                                    this.props.ele.manualAddressEntryLabelFRA = nextValue;
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-unknown-address" + this.props.ele.Sequence}>
                            I can't find the address or I don't know the full address
                        </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            value={this.props.ele.allowUnknownAddress}
                            id={"allow-unknown-address" + this.props.ele.Sequence}
                            checked={this.props.ele.allowUnknownAddress}
                            onChange={(e) => { this.props.ele.allowUnknownAddress = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Is BXP address: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.isBXPaddress} id={"is-bxp-address" + this.props.ele.Sequence}
                            checked={this.props.ele.isBXPaddress}
                            onChange={(e) => { this.props.ele.isBXPaddress = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Is city optional: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.isMunicipalityOptional} id={"is-city-optional" + this.props.ele.Sequence}
                            checked={this.props.ele.isMunicipalityOptional}
                            onChange={(e) => { this.props.ele.isMunicipalityOptional = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Is province optional: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.isProvinceOptional} id={"is-province-optional" + this.props.ele.Sequence}
                            checked={this.props.ele.isProvinceOptional}
                            onChange={(e) => { this.props.ele.isProvinceOptional = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                

                      <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Is post code optional: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.isPostCodeOptional} id={"is-post-code-optional" + this.props.ele.Sequence}
                            checked={this.props.ele.isPostCodeOptional}
                            onChange={(e) => { this.props.ele.isPostCodeOptional = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"use-touched-non-bxp-errors" + this.props.ele.Sequence}>Show non-BXP city/postal errors only after touched: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            value={this.props.ele.useTouchedForNonBxpErrors}
                            id={"use-touched-non-bxp-errors" + this.props.ele.Sequence}
                            checked={this.props.ele.useTouchedForNonBxpErrors}
                            onChange={(e) => { this.props.ele.useTouchedForNonBxpErrors = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Is street number optional: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.isStreetNumberOptional} id={"is-street-number-optional" + this.props.ele.Sequence}
                            checked={this.props.ele.isStreetNumberOptional}
                            onChange={(e) => { this.props.ele.isStreetNumberOptional = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"free-text-street-number" + this.props.ele.Sequence}>Allow free-text street number: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.freeTextStreetNumber} id={"free-text-street-number" + this.props.ele.Sequence}
                            checked={this.props.ele.freeTextStreetNumber}
                            onChange={(e) => { this.props.ele.freeTextStreetNumber = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>

                 <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Is street name optional: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.isStreetNameOptional} id={"is-street-name-optional" + this.props.ele.Sequence}
                            checked={this.props.ele.isStreetNameOptional}
                            onChange={(e) => { this.props.ele.isStreetNameOptional = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>

                 <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>Is Other optional: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.isOtherOptional} id={"is-other-optional" + this.props.ele.Sequence}
                            checked={this.props.ele.isOtherOptional}
                            onChange={(e) => { this.props.ele.isOtherOptional = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>


                    <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>hide Country field: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideCountry} id={"hide-country" + this.props.ele.Sequence}
                            checked={this.props.ele.hideCountry}
                            onChange={(e) => { this.props.ele.hideCountry = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"show-country-field" + this.props.ele.Sequence}>Show Country (Non BXP): </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            value={this.props.ele.showCountryField}
                            id={"show-country-field" + this.props.ele.Sequence}
                            checked={this.props.ele.showCountryField}
                            onChange={(e) => { this.props.ele.showCountryField = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"auto-set-country-from-province" + this.props.ele.Sequence}>
                            Auto set country to Canada when province is not Other:
                        </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            value={this.props.ele.autoSetCountryFromProvince}
                            id={"auto-set-country-from-province" + this.props.ele.Sequence}
                            checked={this.props.ele.autoSetCountryFromProvince}
                            onChange={(e) => { this.props.ele.autoSetCountryFromProvince = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>hide Rural Route: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideRuralRoute} id={"hide-rural-route" + this.props.ele.Sequence}
                            checked={this.props.ele.hideRuralRoute}
                            onChange={(e) => { this.props.ele.hideRuralRoute = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>hide P.O Box: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hidePOBox} id={"hide-rural-route" + this.props.ele.Sequence}
                            checked={this.props.ele.hidePOBox}
                            onChange={(e) => { this.props.ele.hidePOBox = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"hide-unit-type" + this.props.ele.Sequence}>Hide unit type: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideUnitType} id={"hide-unit-type" + this.props.ele.Sequence}
                            checked={this.props.ele.hideUnitType}
                            onChange={(e) => { this.props.ele.hideUnitType = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div><div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"suppress-unit-on-address-search" + this.props.ele.Sequence}>Suppress unit field input: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.suppressUnitOnAddressSearch} id={"suppress-unit-on-address-search" + this.props.ele.Sequence}
                            checked={this.props.ele.suppressUnitOnAddressSearch}
                            onChange={(e) => { this.props.ele.suppressUnitOnAddressSearch = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"hide-street-number-suffix" + this.props.ele.Sequence}>Hide street number suffix: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideStreetNumberSuffix} id={"hide-street-number-suffix" + this.props.ele.Sequence}
                            checked={this.props.ele.hideStreetNumberSuffix}
                            onChange={(e) => { this.props.ele.hideStreetNumberSuffix = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"hide-unit-type" + this.props.ele.Sequence}>Hide unit type: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideUnitType} id={"hide-unit-type" + this.props.ele.Sequence}
                            checked={this.props.ele.hideUnitType}
                            onChange={(e) => { this.props.ele.hideUnitType = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"hide-street-number-suffix" + this.props.ele.Sequence}>Hide street number suffix: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideStreetNumberSuffix} id={"hide-street-number-suffix" + this.props.ele.Sequence}
                            checked={this.props.ele.hideStreetNumberSuffix}
                            onChange={(e) => { this.props.ele.hideStreetNumberSuffix = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>hide street type: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideStreetType} id={"hide-street-type" + this.props.ele.Sequence}
                            checked={this.props.ele.hideStreetType}
                            onChange={(e) => { this.props.ele.hideStreetType = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"allow-manual-edit" + this.props.ele.Sequence}>hide street direction: </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.hideStreetDirection} id={"hide-street-direction" + this.props.ele.Sequence}
                            checked={this.props.ele.hideStreetDirection}
                            onChange={(e) => { this.props.ele.hideStreetDirection = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"lockStreetFieldsAfterPopulate_" + this.props.ele.Sequence}>
                            Lock street number/name/type after populated
                        </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            value={this.props.ele.lockStreetFieldsAfterPopulate}
                            id={"lockStreetFieldsAfterPopulate_" + this.props.ele.Sequence}
                            checked={this.props.ele.lockStreetFieldsAfterPopulate}
                            onChange={(e) => { this.props.ele.lockStreetFieldsAfterPopulate = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"returnAddressObject" + this.props.ele.Sequence}>Return object in payload</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.returnAdrressObject} id={"address-object-in-payload_" + this.props.ele.Sequence}
                            checked={this.props.ele.returnAdrressObject}
                            onChange={(e) => { this.props.ele.returnAdrressObject = e.checked; this.props.callback() }} 
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Address type: </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear options={addressTypeOption} optionLabel='label' optionValue='val' value={this.props.ele.addressType}
                            onChange={(e) => {
                                this.props.ele.addressType = e.target.value;
                                this.props.callback();
                            }}
                        ></Dropdown>
                    </div>
                </div>

                {this.props.ele.addressType === 'Mailing' && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Show mailing details when same as residential</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.ele.showMailingDetails} id={"show-mainling-detail" + this.props.ele.Sequence}
                                checked={this.props.ele.showMailingDetails}
                                onChange={(e) => { this.props.ele.showMailingDetails = e.checked; this.props.callback() }} 
                            />
                        </div>
                    </div>
                )}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Show mailing details when same as residential</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.showMailingDetails} id={"show-mainling-detail" + this.props.ele.Sequence}
                            checked={this.props.ele.showMailingDetails}
                            onChange={(e) => { this.props.ele.showMailingDetails = e.checked; this.props.callback() }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop:'10px'}}>
                   <div style={{width: '25%'}}>
                        <label htmlFor={"canadianaddress_" + this.props.ele.Sequence}>Canadian Address</label>
                   </div> 
                   <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox value={this.props.ele.CanadianAddress} id={"canadianaddress_" +this.props.ele.Sequence}
                        onChange={(e) => {this.props.ele.CanadianAddress = e.checked; this.props.callback() }} checked={this.props.ele.CanadianAddress} />
                   </div>
                </div>

                <div style={{ display: "flex", marginTop:'10px'}}>
                   <div style={{width: '25%'}}>
                        <label htmlFor={"hideaddressdetails_" + this.props.ele.Sequence}>Hide additional address fields</label>
                   </div> 
                   <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox value={this.props.ele.hideAddressDetails } id={"hideaddressdetails_" +this.props.ele.Sequence}
                        onChange={(e) => {this.props.ele.hideAddressDetails = e.checked; this.props.callback() }} checked={this.props.ele.hideAddressDetails} />
                   </div>
                </div>

                <div style={{ display: "flex", marginTop:'10px'}}>
                   <div style={{width: '25%'}}>
                        <label htmlFor={"hideStreetNumberSuffix_" + this.props.ele.Sequence}>Hide 'Street number suffix' field</label>
                   </div> 
                   <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox value={this.props.ele.hideStreetNumberSuffix } id={"hideStreetNumberSuffix_" +this.props.ele.Sequence}
                        onChange={(e) => {this.props.ele.hideStreetNumberSuffix = e.checked; this.props.callback() }} checked={this.props.ele.hideStreetNumberSuffix} />
                   </div>
                </div>

                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label htmlFor={"hideStreetNumberNameCheckbox_" + this.props.ele.Sequence}>
                            Hide 'Street Number/Name' Checkbox field
                        </label>
                    </div>
                    <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox
                            value={this.props.ele.hideStreetNumberNameCheckbox}
                            id={"hideStreetNumberNameCheckbox_" + this.props.ele.Sequence}
                            onChange={(e) => {
                                this.props.ele.hideStreetNumberNameCheckbox = e.checked;
                                this.props.callback()
                            }} checked={this.props.ele.hideStreetNumberNameCheckbox}/>
                    </div>
                </div>

                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label htmlFor={"combineStreetFields_" + this.props.ele.Sequence}>
                            Combine street number and name into Street num field
                        </label>
                    </div>
                    <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox
                            value={this.props.ele.combineStreetFields}
                            id={"combineStreetFields_" + this.props.ele.Sequence}
                            onChange={(e) => {
                                this.props.ele.combineStreetFields = e.checked;
                                this.props.callback()
                            }} checked={this.props.ele.combineStreetFields}/>
                    </div>
                </div>

                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label htmlFor={"commaAfterStreetNumber_" + this.props.ele.Sequence}>
                            Add comma between street number and street name
                        </label>
                    </div>
                    <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox
                            value={this.props.ele.commaAfterStreetNumber}
                            id={"commaAfterStreetNumber_" + this.props.ele.Sequence}
                            onChange={(e) => {
                                this.props.ele.commaAfterStreetNumber = e.checked;
                                this.props.callback()
                            }} checked={this.props.ele.commaAfterStreetNumber}/>
                    </div>
                </div>

                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label htmlFor={"populateUnitInStreetNumber_" + this.props.ele.Sequence}>
                            Populate unit number in street number
                        </label>
                    </div>
                    <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox
                            value={this.props.ele.populateUnitInStreetNumber}
                            id={"populateUnitInStreetNumber_" + this.props.ele.Sequence}
                            onChange={(e) => {
                                this.props.ele.populateUnitInStreetNumber = e.checked;
                                this.props.callback()
                            }} checked={this.props.ele.populateUnitInStreetNumber}/>
                    </div>
                </div>

                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label htmlFor={"restrictManualAndNoStreet_" + this.props.ele.Sequence}>
                            Restrict manual entry and no street name/number (mutually exclusive)
                        </label>
                    </div>
                    <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox
                            value={this.props.ele.restrictManualAndNoStreet}
                            id={"restrictManualAndNoStreet_" + this.props.ele.Sequence}
                            onChange={(e) => {
                                this.props.ele.restrictManualAndNoStreet = e.checked;
                                this.props.callback()
                            }} checked={this.props.ele.restrictManualAndNoStreet}/>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop:'10px'}}>
                   <div style={{width: '25%'}}>
                        <label htmlFor={"AlwaysDisplayCity_" + this.props.ele.Sequence}>Always Display City</label>
                   </div> 
                   <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox value={this.props.ele.AlwaysDisplayCity} id={"AlwaysDisplayCity_" +this.props.ele.Sequence}
                        onChange={(e) => {this.props.ele.AlwaysDisplayCity = e.checked; this.props.callback() }} 
                        checked={this.props.ele.AlwaysDisplayCity} />
                   </div>
                </div>

                <div style={{ display: "flex", marginTop:'10px'}}>
                   <div style={{width: '25%'}}>
                        <label htmlFor={"AlwaysDisplayProvince_" + this.props.ele.Sequence}>Always Display Province</label>
                   </div> 
                   <div style={{width: '60%'}}>
                        {/*@ts-ignore*/}
                        <Checkbox value={this.props.ele.AlwaysDisplayProvince} id={"AlwaysDisplayProvince_" +this.props.ele.Sequence}
                        onChange={(e) => {this.props.ele.AlwaysDisplayProvince = e.checked; this.props.callback() }} 
                        checked={this.props.ele.AlwaysDisplayProvince} />
                   </div>
                </div>

                    {this.renderAddressLabelOverrideAccordion()}
                    {this.renderAddressErrorOverrideAccordion()}

                {this.maskSummaryHtml()}

                {this.excludeFromPayload()}

            </>
        )

        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
